import { render, staticRenderFns } from "./ModalPaymentLimit.vue?vue&type=template&id=66aae4cc&"
import script from "./ModalPaymentLimit.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentLimit.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaymentLimit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports